'use client';
import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { Component } from 'react';

function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
var initialState = {
    hasError: false,
    error: null
};
var ErrorBoundary = /*#__PURE__*/ function(Component) {
    _inherits(ErrorBoundary, Component);
    function ErrorBoundary(props) {
        var _this;
        _this = Component.call(this, props) || this;
        _this.resetErrorBoundary = _this.resetErrorBoundary.bind(_assert_this_initialized(_this));
        _this.state = initialState;
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.resetErrorBoundary = function resetErrorBoundary() {
        if (this.state.error !== null) {
            var _this_props_onReset, _this_props;
            (_this_props_onReset = (_this_props = this.props).onReset) == null ? void 0 : _this_props_onReset.call(_this_props);
        }
        this.setState(initialState);
    };
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        var _this_props_onCatch, _this_props;
        (_this_props_onCatch = (_this_props = this.props).onCatch) == null ? void 0 : _this_props_onCatch.call(_this_props, error, errorInfo);
    };
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, RenderFallback = _this_props.renderFallback;
        var _this_state = this.state, hasError = _this_state.hasError, error = _this_state.error;
        if (hasError) {
            return /*#__PURE__*/ jsx(RenderFallback, {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            });
        }
        return /*#__PURE__*/ jsx(Fragment, {
            children: children
        });
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    };
    return ErrorBoundary;
}(Component);
var ErrorBoundary$1 = ErrorBoundary;

export { ErrorBoundary, ErrorBoundary$1 as default };
